import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import UnifiedCCOffersContainer from 'partial/OfferManager/UnifiedCCOffersContainer';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import './PreApprovedOcfModuleView.scss';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';
import MoreWaysToBrowseCard from 'pages/Ocf/components/MoreWaysToBrowseCard';

const PreApprovedOcfModuleView = props => {
  const pageName = `PreApprovedOcfModule`;
  const defaultTestId = pageName;
  return (
    <>
      <SectionContainer
        className={'preApprovedOcfContainer  m-padL4'}
        datatestid={`${defaultTestId}`}
      >
        <HeaderSwitch {...props} />
        <Row fullWidth className="ocfDisclaimer margT32 margLR48 m-margLR0">
          <Disclaimer showPartnerText vertical={CREDIT_CARD_VERTICAL} />
        </Row>
        <UnifiedCCOffersContainer
          datatestid={`${defaultTestId}-unifiedCCOffers`}
          offers={props.offers}
          isOcfPage={props?.isOcfPage}
          eventHandler={props?.eventHandler}
          partnersCustomTrackingMeta={props?.partnersCustomTrackingMeta}
          containerType={props?.containerType}
          isHighlightFirstCard={true}
          pagePosition={props.moduleName}
          showSeeMoreCardsLink={false}
        />
      </SectionContainer>
    </>
  );
};

const HeaderSwitch = props => {
  if (props.showBadgeHeader) {
    return <BadgeHeader {...props} />;
  } else {
    return <ApplyWithConfidenceHeader />;
  }
};

const BadgeHeader = props => {
  return (
    <Row>
      <FlexContainer>
        <Label className={'H3'}>
          Hey {props.userInfoOcf?.firstName}, here are your new credit card
          approval odds!
        </Label>
      </FlexContainer>
    </Row>
  );
};

const ApplyWithConfidenceHeader = props => {
  return (
    <Row>
      <FlexContainer>
        <FlexContainer className={'flex-column'}>
          <Label typeHeader={'h3'} className={'H3 m-H3'}>
            Congrats, your highest approval odds are here!
          </Label>
          <Label className={'Body-1 margT8 mBody-2'}>
            {
              'Looking for a new card? Here are some great options based on your credit profile and approval odds.'
            }
          </Label>
        </FlexContainer>
        <FlexContainer className={'imageContainer justify-center m-hide '}>
          <Image imgClass={'applyWithConfidenceImage bgImageW150'} />
        </FlexContainer>
      </FlexContainer>
    </Row>
  );
};

export default PreApprovedOcfModuleView;
